import { useState } from "react";
import styles from "./Faqs.module.css";
import { Typography } from "@grantyd/ui";
import { ReactComponent as ArrowIcon } from "@/assets/icons/arrow-down.svg";
import { faqContent as content } from "@/data/landingpage";

interface FaqsProps {
  content: typeof content;
}
const Faqs = ({ content }: FaqsProps) => {
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  const toggleFaq = (index: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  return (
    <div className={styles.faqSection} id="faqSection">
      <div className={styles.faqHeader}>
        <Typography
          as="h2"
          color="primary"
          variant="headline-lg"
          style={{ fontWeight: "var(--font-weight-bold) !important" }}
        >
          {content.title}
        </Typography>
      </div>

      <div className={styles.faqList}>
        {content.faqs.map((item, index) => (
          <div
            key={index}
            className={`${styles.faqItem} ${
              expandedItems.has(index) ? styles.active : ""
            }`}
            data-testid={`faq-item-${index}`}
          >
            <div
              className={styles.faqButton}
              onClick={() => toggleFaq(index)}
              role="button"
              data-testid={`faq-button-${index}`}
            >
              <Typography as="p" variant="title-md" color="primary">
                {item.question}
              </Typography>
              <ArrowIcon
                className={`${styles.icon} ${expandedItems.has(index) ? styles.iconRotate : ""}`}
              />
            </div>
            <div className={styles.faqContent}>
              <Typography as="p" variant="body-md" color="primary">
                {item.answer}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
